<template>
  <div class="container text-center">
    <h3 class="title hide-in-mobile">Let's block some fraud</h3>
    <h3 class="title hide-in-desktop">Let's block click fraud<br> on your campaigns</h3>
    <span class="sub-title hide-in-desktop">Start your 7 days FREE trial</span>

    <div class="card">
      <span class="subtitle hide-in-mobile">Start your 7 days FREE trial</span>
      <form  @submit.prevent>

        <label>
          <span v-if="form.email.error" class="text-danger text-left" v-text="'Enter valid email address.'"/>
          <span>Your work email</span>
          <input v-model="form.email.value" :class="{ error: form.email.error }" type="email" name="email" >
        </label>

        <label>
          <span v-if="form.password.error" class="text-danger text-left" v-text="'Enter valid password.'"/>
          <span>Password</span>
          <input v-model="form.password.value" :class="{ error: form.password.error }" type="password" name="password" placeholder="Must include letters and numbers">
        </label>

        <label>
          <span v-if="form.phone.error" class="text-danger text-left" v-text="form.phone.error"/>
          <span>Phone - <i>optional</i></span>
          <input
            ref="phone"
            type="tel"
            name="phone"
            v-model="form.phone.value"
            :class="{ error: form.phone.error }"
            style="width: 100%"
            id="phone"
          />
        </label>

        <div :class="{ 'multi-select' : !is_single_domain }" @click="showMultiSelect">
          <label class="select-wrapper" >
            <span>Domain to protect</span>
            <select v-model="form.domain.value" :class="{ error: form.domain.error }" name="domain" :disabled="is_single_domain">
              <option v-if="is_single_domain" v-for="domain of get_domains" :value="domain.Address" v-text="domain.Address" :key="domain.Address" selected />
              <option v-else value="" v-text="'Select domain to protect'" selected />
            </select>
          </label>

          <!--    Only for multiple domains       -->
          <template v-if="!is_single_domain">
            <div class="over-select" />
            <div id="checkboxes" class="hide">
              <template v-for="domain of get_domains" :key="domain.Address">
                <label :for="domain.Address" >
                  <input type="checkbox" :id="domain.Address" @change="handleMultipleDomains( domain.Address )"/>{{ domain.Address }}
                  <span class="circle-indicator" />
                </label>
              </template>
            </div>
          </template>
        </div>

        <button class="btn-orange" @click="handleForm">Start your 7-day FREE trial</button>
        <terms-and-conditions />

      </form>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { useIntlTelInput } from "@/hooks/useIntlTelInput";
import { sendReportDataLayer } from "@/utils";
import TermsAndConditions from "@/components/TermsAndConditions";

export default {
  name: "Signup",
  components: {
    TermsAndConditions,
  },
  data() {
    const email_cta = this.$store.getters.get_email_cta
    return {
      form: {
        email: {
          value: email_cta,
          error: null,
          required: true,
          validation: (str) => /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(str),
        },
        password: {
          value: '',
          error: null,
          required: true,
          validation: (str) => /^[A-Za-z]\w{6,14}$/.test(str),
        },
        phone: {
          value: '',
          error: null,
          combineValue: null
        },
        domain: {
          value: '',
          error: false,
        },
        domains: [],
      }
    }
  },
  mounted() {
    this.phoneNumberInput = useIntlTelInput({ telInput: this.$refs.phone });
    this.sendEvent();
  },
  computed: {
    ...mapGetters(['get_email_cta', 'get_domains']),

    errors() {
      for ( const field in this.form ) {
        if (this.form[field].error)
          return true;
      }
      return false;
    },

    is_single_domain() {
      return this.get_domains.length === 1;
    }
  },
  methods: {
    ...mapActions(['USER_SIGNUP']),

    checkForm() {
      for ( const field in this.form ) {
        const input = this.form[field];

        if ( input.required ) {
          input.error = input.validation
            ? !input.validation( input.value )
            : !input.value;
        }
        else if ( field === 'phone' ) {
          this.setPhoneNumber();
        }
        else if ( field === 'domain' ) {
          this.setPhoneNumber();
        }
      }
    },

    setPhoneNumber() {
      try {
        const phone = this.form.phone;
        const placeholderLength = this.$refs.phone?.placeholder.replace(/\D/g,'').length;
        const pre = document.querySelector('.iti__selected-flag').title.split(': ')[1] ?? '';
        phone.error = null;

        if( !phone.value ) return;
        else if ( isNaN(phone.value) )                         phone.error = 'Please input a valid number.';
        else if ( placeholderLength > phone.value.length )     phone.error = 'The number is to short.';
        else if ( placeholderLength + 1 < phone.value.length ) phone.error = 'The number is to long.';

        if ( phone.error ) return;
        phone.combineValue = `${ pre }${ phone.value }`;
      } catch (err) {
        console.error(err)
      }
    },

    async handleForm() {
      this.checkForm();
      if (this.errors) return;
      let userDetails = {
        email: this.form.email.value,
        password: this.form.password.value,
        domain: this.getSignupDomain(),
      }
      if ( this.form.phone.value && !this.form.phone.error )
        userDetails.phone = this.form.phone.combineValue;

      return this.domains.length > 1
        ? await this.USER_SIGNUP(userDetails)
        : await this.USER_SIGNUP(userDetails, this.domains);
    },

    /**
     * In case of multiple domain this function will creat a list separated by ";"
     * If address is in the list  then it will toggled out
     *
     * @param address
     * @return void
     */
    handleMultipleDomains(address) {
      const domains = this.form.domains;

      if ( !domains.length || !domains.includes( address ) )
        domains.push( address );
      else
        this.form.domains = domains.filter(item => item !== address);
    },

    getSignupDomain() {
      return this.domains[0]?.Address;
      // if ( this.is_single_domain )
      //   return this.domains[0]?.Address;
      // return this.form.domains.shift(); // TODO: find out if this commented is required or just the first line
    },

    showMultiSelect(e) {
      const checkboxes = document.getElementById("checkboxes");
      if ( checkboxes.classList.contains('hide') ) {
        checkboxes.classList.remove("hide");
      }
      else if (e.target.classList.contains('over-select')) {
        checkboxes.classList.add("hide");
      }
    },

    sendEvent() {
      sendReportDataLayer({
        report_step: 6,
        report_step_name: 'signup',
      });
    },
  },
}
</script>

<style lang="scss" scoped>
@import "src/assets/style/responsive";
@import "src/assets/style/colors";

form label {
  margin-top: 20px;

  &:first-child {
    margin-top: 40px;
  }
}
.sub-title {
  @include mobile {
    font-size: 20px;
  }
}
.subtitle {
  font-family: "Sofia Pro";
  font-size: 29px;
  text-align: center;
  color: $black;
}
.card {
  width: 100%;
  max-width: 456px;
  margin: 40px auto 80px auto;

  @include mobile {
    background: transparent;
    box-shadow: unset;
    padding: unset;
  }
}
.btn-orange {
  margin-top: 44px;

  @include mobile {
    margin-top: 48px;
  }
}
.multi-select {
   position: relative;
  .over-select {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
  }
  #checkboxes {
    position: absolute;
    top: 70px;
    width: 100%;
    max-height: 120px;
    padding: 10px 15px;
    background: $white;
    border: 1px solid $lightGrayBorder;
    border-radius: 20px;
    overflow-x: hidden;
    overflow-y: scroll;

    &.hide {
      display: none;
    }
    label {
      position: relative;
      margin-top: 8px;
      margin-bottom: 8px;
      width: 100%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      user-select: none;

      input {
        opacity: 0;
        margin-right: 10px;
      }
      .circle-indicator {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        height: 1em;
        width: 1em;
        border-radius: 50px;
        background: #eee;
        border: 1px solid $lightGrayBorder;
      }
      input:checked ~ .circle-indicator {
        border: 1px solid $orange;
        background: $orange;
      }
    }
  }
}
</style>

<style lang="scss">
.iti.iti--allow-dropdown.iti--separate-dial-code {
  width: 100%;

  .iti__selected-flag {
    overflow: hidden;
    border-top-left-radius: 20px;
    border-bottom-left-radius: 20px;
  }
}
</style>